import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface EditConfirmAlertProps {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  onSubmit: () => Promise<void>;
  loading: boolean;
}

export const EditConfirmAlert = ({ opened, setOpened, onSubmit, loading }: EditConfirmAlertProps) => {
  const { palette } = useCustomTheme();
  const { sm } = useScreen();

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={() => {
        setOpened(false);
      }}
      onSubmit={async () => {
        await onSubmit();
        setOpened(false);
      }}
      Title={<Text tId={'WARNING'} />}
      MainButton={<Text tId={'EDIT_CONFIRM_ALERT_BUTTON'} />}
      loading={loading}
    >
      <FlexRow gridGap={24} justifyContent="flex-start">
        <Icon size={sm ? 30 : 24} color={palette.warning.main}>
          warning
        </Icon>
        <Font variant={'body2'} color={'textPrimary'}>
          <Text tId={'EDIT_CONFIRM_ALERT_DESCRIPTION'} />
        </Font>
      </FlexRow>
    </ActionDialog>
  );
};
